module.exports = __webpack_public_path__ + "static/media/nequi.960e0e2c.svg";